// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"792":"main","884":"admin"}[chunkId] + ".css";
};